import { formatRefDate } from '../../../utils/formatRefDate';
import { Button, Form, Input, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { ArrowRightOutlined, SearchOutlined } from '@ant-design/icons';
import { GetHistorical, GetHistoricalBunker, GetLastSPAL, GetSPALActivity } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { Option } = Select;

const FilterSPAL = ({ onData, onDataToleransi, onLoading }) => {

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    // const [loadings, setLoadings] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const [dataSPAL, setDataSPAL] = useState([]);
    const [activity, setActivity] = useState([]);
    const [selectedSPAL, setSelectedSPAL] = useState(null);
    const [selectedActivity1, setSelectedActivity1] = useState(null);
    const [selectedActivity2, setSelectedActivity2] = useState(null);

    const selectedItem = dataSPAL.find((item) => item.SONumber === selectedSPAL);

    useEffect(() => {
        const fetchSPAL = async () => {
            try {
                const res = await GetLastSPAL(KodeCabang, ShipCode, 0);
                if (res && res.length > 0) {
                    setDataSPAL(res);
                    if (res.length > 0) {
                        const defaultSPAL = res[0];
                        setSelectedSPAL(defaultSPAL.SONumber);
                        form.setFieldsValue({
                            SPAL: defaultSPAL.SONumber,
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchSPAL();
    }, [KodeCabang, ShipCode, form]);

    useEffect(() => {
        const fetchActivity = async () => {
            try {
                const res = await GetSPALActivity(KodeCabang, selectedSPAL);
                setActivity(res);
                if (res && res.length > 0) {  // Ensure res is not null/undefined and has elements
                    const firstActivity = res[0];
                    const lastActivity = res[res.length - 1];
                    setSelectedActivity1(firstActivity.ActivityDate);
                    setSelectedActivity2(lastActivity.ActivityDate);
                    form.setFieldsValue({
                        activity1: firstActivity.ActivityDate,
                        activity2: lastActivity.ActivityDate,
                    });
                    fetchDataReading(dayjs.utc(firstActivity.ActivityDate).format('YYYY-MM-DD HH:mm:ss'), dayjs.utc(lastActivity.ActivityDate).format('YYYY-MM-DD HH:mm:ss'))
                }
            } catch (error) {
                console.error("Error fetching SPAL data:", error);
            }
        }

        fetchActivity();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, selectedSPAL]);

    const onSubmit = async (values) => {
        const { activity1, activity2 } = values;

        const startDateRange = dayjs.utc(activity1).format('YYYY-MM-DD HH:mm:ss');
        const endDateRange = dayjs.utc(activity2).format('YYYY-MM-DD HH:mm:ss');

        if (endDateRange && startDateRange && dayjs(endDateRange).isBefore(dayjs(startDateRange))) {
            message.error('Activity 2 cannot be before Activity 1');
            return;
        }

        try {
            await fetchDataReading(startDateRange, endDateRange);
        } catch (error) {
            console.log(error);
        }
    };


    const fetchDataReading = async (start, end) => {
        try {
            setIsLoading(true);
            onLoading(true);
            // const response = await getHistoryCal(start, end, onDataToleransi[0], onDataToleransi[1]);
            // const response = await GetHistorical(KodeCabang, ShipCode, start, end, onDataToleransi[0], onDataToleransi[1]);
            const [response] = await GetHistoricalBunker({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                StartDate: start,
                EndDate: end,
            });
            onData(response);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            onLoading(false);
        }
    };

    return (
        <div>
            <Form
                layout="vertical"
                onFinish={onSubmit}
                form={form}
                initialValues={{
                    SPAL: selectedSPAL,
                    activity1: selectedActivity1,
                    activity2: selectedActivity2,
                }}
            >
                <div className="analytics-filter">
                    <div className="analytics-filter-fields">
                        <Form.Item
                            name="SPAL" label="SPAL / Voyage"
                        >
                            <Select
                                onChange={(value) => setSelectedSPAL(value)}
                                className="w-full"
                                placeholder="Select SPAL"
                                popupMatchSelectWidth={true}
                                popupClassName="analytics-select-popup"
                                disabled={isLoading}
                                optionLabelProp="label"
                                options={(dataSPAL || []).map((item) => ({
                                    value: item.SONumber,
                                    label: item.SONumber,
                                    ...item,
                                }))}
                                optionRender={(option) => {
                                    const item = option.data;
                                    return (
                                        <div className="flex flex-col gap-1.5 py-0.5 analytics-option">
                                            <div className="flex items-center justify-between gap-3">
                                                <span className="text-sm font-semibold text-gray-800">{item.SONumber}</span>
                                                <span className={`shrink-0 text-[10px] leading-none px-2 py-1 rounded-full font-medium ${item.IsFinish ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`}>
                                                    {item.IsFinish ? 'FINISH' : 'UNFINISHED'}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-blue-50 text-blue-700 text-xs font-medium">
                                                    <span className="text-[9px] uppercase tracking-wide text-blue-400">Load</span>
                                                    {item.LoadPositionName}
                                                </span>
                                                <ArrowRightOutlined className="text-[10px] text-gray-400" />
                                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-orange-50 text-orange-700 text-xs font-medium">
                                                    <span className="text-[9px] uppercase tracking-wide text-orange-400">Unload</span>
                                                    {item.UnloadPositionName}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                        </Form.Item>

                        <Input
                            readOnly
                            disabled={isLoading}
                            className="w-full"
                            placeholder="Load Position"
                            addonBefore="Load"
                            value={selectedItem?.LoadPositionName || ''}
                        />
                        <Input
                            readOnly
                            disabled={isLoading}
                            className="w-full"
                            placeholder="Unload Position"
                            addonBefore="Unload"
                            value={selectedItem?.UnloadPositionName || ''}
                        />

                        <Form.Item
                            name="activity1" label="Start Activity"
                        >
                            <Select
                                style={{ minWidth: '100px', width: 'auto' }}
                                placeholder="Select Activity 1"
                                popupMatchSelectWidth={true}
                                popupClassName="analytics-select-popup"
                                disabled={isLoading}
                            >
                                {(activity || []).map((item) => (
                                    <Option key={item.DetailNo} value={item.ActivityDate}>
                                        {item.ActivityName} - {formatRefDate(item.ActivityDate)}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="activity2" label="End Activity"
                        >
                            <Select
                                style={{ minWidth: '100px', width: 'auto' }}
                                placeholder="Select Activity 2"
                                popupMatchSelectWidth={true}
                                popupClassName="analytics-select-popup"
                                disabled={isLoading}
                            >
                                {(activity || []).map((item) => (
                                    <Option key={item.DetailNo} value={item.ActivityDate}>
                                        {item.ActivityName} - {formatRefDate(item.ActivityDate)}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={isLoading}>Apply</Button>
                </div>
            </Form>
        </div>
    );
}

export default FilterSPAL;
